import { DragDropContext } from "@hello-pangea/dnd";

export default function DragAndDropContext(props) {
	return <DragDropContext {...props} />;
}
